/** Collect path `d` strings from a layer node (split or joined). */
export function collectLayerPathDs(layer) {
  if (!layer) return [];
  const dStrings = [];
  const collectD = (node) => {
    const d = node?.attributes?.d;
    if (d && d.trim()) dStrings.push(d);
    node?.children?.forEach(collectD);
  };
  if (layer.children?.length) {
    layer.children.forEach(collectD);
  } else if (layer.attributes?.d?.trim()) {
    dStrings.push(layer.attributes.d);
  }
  return dStrings;
}

export const POTRACE_ALPHA_THRESHOLD = 72;

/** Fewer opaque pixels than this → treat the layer as fully erased. */
export const MIN_REMAINING_SHAPE_PIXELS = 12;

export function countShapePixels(imageData, alphaThreshold = POTRACE_ALPHA_THRESHOLD) {
  let count = 0;
  const data = imageData.data;
  for (let i = 3; i < data.length; i += 4) {
    if (data[i] > alphaThreshold) count++;
  }
  return count;
}

export function isCanvasEffectivelyEmpty(imageData, alphaThreshold = POTRACE_ALPHA_THRESHOLD) {
  return countShapePixels(imageData, alphaThreshold) < MIN_REMAINING_SHAPE_PIXELS;
}

/** Build a black-on-white bitmap canvas suitable for Potrace. */
export function buildPotraceBitmapCanvas(imageData, W, H, alphaThreshold = POTRACE_ALPHA_THRESHOLD) {
  const bwCanvas = document.createElement("canvas");
  bwCanvas.width = W;
  bwCanvas.height = H;
  const bwCtx = bwCanvas.getContext("2d");
  bwCtx.fillStyle = "#ffffff";
  bwCtx.fillRect(0, 0, W, H);
  const bwData = bwCtx.getImageData(0, 0, W, H);
  const src = imageData.data;
  const dst = bwData.data;
  for (let i = 0; i < src.length; i += 4) {
    if (src[i + 3] > alphaThreshold) {
      dst[i] = dst[i + 1] = dst[i + 2] = 0;
      dst[i + 3] = 255;
    }
  }
  bwCtx.putImageData(bwData, 0, 0);
  return bwCanvas;
}

/** Potrace params tuned for pixel erase — keep tiny remnants until truly gone. */
export const PIXEL_ERASE_POTRACE_PARAMS = {
  turdSize: 0,
  optTolerance: 0.2,
  alphaMax: 1,
  threshold: 128,
};
